import { render, staticRenderFns } from "./HealthcareExpenseClaims.vue?vue&type=template&id=5962b602&scoped=true"
import script from "./HealthcareExpenseClaims.vue?vue&type=script&lang=ts"
export * from "./HealthcareExpenseClaims.vue?vue&type=script&lang=ts"
import style0 from "./HealthcareExpenseClaims.vue?vue&type=style&index=0&id=5962b602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5962b602",
  null
  
)

export default component.exports